// src/components/admin/ListaUsuarios.js
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import HeaderAdmin from "../header/HeaderAdmin";
import backgroundImage from "../../assets/img/fondoSiete.png";
import Descargar from "../../assets/img/Descargar.svg";
import EditarUsuario from "./EditarUsuario";
import useListaUsuarios from "../../hooks/useListaUsuarios";
import DetallesResultados from "./DetallesResultados";
import UploadUsuariosExcel from "../usuario/UploadUsuariosExcel";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "";

const ListaUsuarios = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedUsuario, setSelectedUsuario] = useState(null);
  const [showUpload, setShowUpload] = useState(false);

  // Nuevo: estado para modal de “Resultados del usuario”
  const [showResultadosUsuario, setShowResultadosUsuario] = useState(false);
  const [usuarioResultados, setUsuarioResultados] = useState(null);

  const {
    usuarios,
    resultados,
    error,
    usuarioEditar,
    currentPage,
    usuariosPorPagina,
    resultadosPorPagina,
    mostrarUsuarios,
    setMostrarUsuarios,
    handleEditar,
    handleCerrarEdicion,
    handleDownloadExcel,
    handleDownloadCertificado,
    paginate,
    totalPages,
    searchTerm,
    setSearchTerm,
    searchTermResultados,
    setSearchTermResultados,
  } = useListaUsuarios();

  const handleVerDetalles = (usuario) => {
    setSelectedUsuario(usuario);
    setShowModal(true);
  };

  function formatTiempo(segundos) {
    const horas = Math.floor(segundos / 3600);
    const minutos = Math.floor((segundos % 3600) / 60);
    const segs = segundos % 60;

    return [
      horas.toString().padStart(2, "0"),
      minutos.toString().padStart(2, "0"),
      segs.toString().padStart(2, "0"),
    ].join(":");
  }

  // Deriva apellidos si no vienen separados desde la API
  function extraerApellidos(nombreCompleto = "") {
    const partes = String(nombreCompleto).trim().split(/\s+/);
    return partes.length > 1 ? partes.slice(1).join(" ") : "";
  }

  // Lógica de paginación para usuarios
  const indexOfLastUsuario = currentPage * usuariosPorPagina;
  const indexOfFirstUsuario = indexOfLastUsuario - usuariosPorPagina;
  const usuariosActuales = usuarios.slice(
    indexOfFirstUsuario,
    indexOfLastUsuario
  );

  // Lógica de paginación para resultados
  const indexOfLastResultado = currentPage * resultadosPorPagina;
  const indexOfFirstResultado = indexOfLastResultado - resultadosPorPagina;
  const resultadosActuales = resultados.slice(
    indexOfFirstResultado,
    indexOfLastResultado
  );

  // Función para generar los botones de paginación
  const renderPaginationButtons = () => {
    const pageNumbers = [];
    let startPage = Math.max(1, currentPage - 4);
    let endPage = Math.min(totalPages, startPage + 6);

    if (endPage - startPage < 6) {
      startPage = Math.max(1, endPage - 6);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <button
          key={i}
          onClick={() => paginate(i)}
          className={`m-1 px-2 sm:px-3 py-1 border rounded text-xs sm:text-sm font-bold ${
            currentPage === i
              ? "bg-green-700 text-white"
              : "bg-white hover:bg-gray-300"
          }`}
        >
          {i}
        </button>
      );
    }

    return (
      <div className="flex flex-wrap justify-center items-center mt-4">
        <button
          onClick={() => paginate(1)}
          disabled={currentPage === 1}
          className="m-1 px-2 sm:px-3 py-1 border rounded text-xs sm:text-sm font-bold bg-white hover:bg-gray-300 disabled:opacity-50"
        >
          &lt;&lt;
        </button>
        <button
          onClick={() => paginate(currentPage - 1)}
          disabled={currentPage === 1}
          className="m-1 px-2 sm:px-3 py-1 border rounded text-xs sm:text-sm font-bold bg-white hover:bg-gray-300 disabled:opacity-50"
        >
          &lt;
        </button>
        {pageNumbers}
        <button
          onClick={() => paginate(currentPage + 1)}
          disabled={currentPage === totalPages}
          className="m-1 px-2 sm:px-3 py-1 border rounded text-xs sm:text-sm font-bold bg-white hover:bg-gray-300 disabled:opacity-50"
        >
          &gt;
        </button>
        <button
          onClick={() => paginate(totalPages)}
          disabled={currentPage === totalPages}
          className="m-1 px-2 sm:px-3 py-1 border rounded text-xs sm:text-sm font-bold bg-white hover:bg-gray-300 disabled:opacity-50"
        >
          &gt;&gt;
        </button>
      </div>
    );
  };

  return (
    <div
      className="min-h-screen flex flex-col"
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <HeaderAdmin />

      <div className="bg-white w-full text-center text-sm sm:text-base md:text-lg font-montserrat font-extrabold mt-2 flex">
        <button
          className={`flex-1 py-2 px-1 sm:px-2 ${
            mostrarUsuarios
              ? "bg-green-700 text-white"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          } transition-colors duration-300`}
          onClick={() => setMostrarUsuarios(true)}
        >
          Lista usuarios
        </button>
        <button
          className={`flex-1 py-2 px-1 sm:px-2 ${
            !mostrarUsuarios
              ? "bg-green-700 text-white"
              : "bg-gray-200 text-gray-700 hover:bg-gray-300"
          } transition-colors duration-300`}
          onClick={() => setMostrarUsuarios(false)}
        >
          Lista resultados
        </button>
      </div>

      <div className="flex-grow flex justify-center mt-2 px-2 sm:px-4">
        <div className="w-full sm:w-11/12 md:w-3/4">
          {error && <p className="text-red-500 mb-2 text-center">{error}</p>}

          <div className="flex justify-end mb-1">
            <div className="relative">
              <input
                type="text"
                placeholder={
                  mostrarUsuarios ? "Buscar usuario..." : "Buscar resultado..."
                }
                value={mostrarUsuarios ? searchTerm : searchTermResultados}
                onChange={(e) =>
                  mostrarUsuarios
                    ? setSearchTerm(e.target.value)
                    : setSearchTermResultados(e.target.value)
                }
                className="pl-8 pr-2 py-1 border rounded text-sm w-48"
              />
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5 absolute left-2 top-1/2 transform -translate-y-1/2 text-gray-400"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                />
              </svg>
            </div>
          </div>

          {mostrarUsuarios ? (
            <>
              <div className="overflow-x-auto">
                <table className="w-full bg-white my-1 sm:my-2 text-center">
                  <thead>
                    <tr className="bg-green-700 text-white">
                      <th className="px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">
                        Nombres
                      </th>
                      <th className="px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">
                        Apellidos
                      </th>
                      <th className="px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">
                        Rol
                      </th>
                      <th className="px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">
                        Facultad
                      </th>
                      <th className="px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">
                        Último inicio de sesión
                      </th>
                      <th className="px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">
                        Acciones
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {usuariosActuales.map((usuario, index) => (
                      <tr key={index} className="bg-white">
                        <td className="border px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat">
                          {usuario.nombre}
                        </td>
                        <td className="border px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat">
                          {usuario.apellido ??
                            usuario.apellidos ??
                            extraerApellidos(usuario.nombre)}
                        </td>
                        <td className="border px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat">
                          {usuario.rol}
                        </td>
                        <td className="border px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat">
                          {usuario.facultad}
                        </td>
                        <td className="border px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat">
                          {usuario.ultimo_inicio_sesion
                            ? new Date(
                                usuario.ultimo_inicio_sesion
                              ).toLocaleString()
                            : "Nunca"}
                        </td>
                        <td className="px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">
                          <button
                            onClick={() => handleEditar(usuario)}
                            className="text-green-700 hover:text-green-600 font-bold py-1 px-2 rounded transition underline duration-300 ease-in-out"
                          >
                            Editar
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {usuarios.length === 0 && !error && (
                <p className="text-white font-montserrat italic mt-4 text-center">
                  No hay usuarios registrados.
                </p>
              )}

              {renderPaginationButtons()}

              <div className="mt-4 flex justify-center">
                <button
                  onClick={() => handleDownloadExcel("usuarios")}
                  className="bg-white mr-4 hover:bg-gray-200 hover:text-black font-bold py-2 px-4 rounded transition duration-300 ease-in-out text-sm sm:text-base transform-transition hover:shadow-[0_9px_20px_rgba(0,0,0,0.8)] transform hover:scale-105"
                >
                  Descargar excel
                </button>

                {/* NUEVO BOTÓN */}
                <button
                  onClick={() => setShowUpload(true)}
                  className="bg-white mr-4 hover:bg-gray-200 hover:text-black font-bold py-2 px-4 rounded transition duration-300 ease-in-out text-sm sm:text-base transform-transition hover:shadow-[0_9px_20px_rgba(0,0,0,0.8)] transform hover:scale-105"
                >
                  Subir usuarios (Excel)
                </button>

                <Link
                  to="/register"
                  className="bg-white hover:bg-gray-200 hover:text-black font-bold py-2 px-4 rounded transition duration-300 ease-in-out text-sm sm:text-base transform-transition hover:shadow-[0_9px_20px_rgba(0,0,0,0.8)] transform hover:scale-105"
                >
                  Registrar usuario
                </Link>
              </div>
            </>
          ) : (
            <div>
              <div className="overflow-x-auto">
                <table className="w-full bg-white my-1 sm:my-2 text-center">
                  <thead>
                    <tr className="bg-green-700 text-white">
                      <th className="px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">
                        Nombre completo
                      </th>
                      <th className="px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">
                        Apellido
                      </th>
                      <th className="px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">
                        Rol
                      </th>
                      <th className="px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">
                        Correctas
                      </th>
                      <th className="px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">
                        Incorrectas
                      </th>
                      <th className="px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat border">
                        Constancias
                      </th>
                    </tr>
                  </thead>

                  <tbody>
                    {resultadosActuales.map((resultado, index) => (
                      <tr key={index} className="bg-white">
                        <td className="border px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat">
                          {resultado.nombre}
                        </td>
                        <td className="border px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat">
                          {resultado.apellido ?? resultado.apellidos ?? ""}
                        </td>
                        <td className="border px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat">
                          {resultado.rol}
                        </td>
                        <td className="border px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat">
                          {resultado.total_correctas}
                        </td>
                        <td className="border px-2 sm:px-4 py-2 text-xs sm:text-sm md:text-base font-montserrat">
                          {resultado.total_incorrectas}
                        </td>
                        <td className="border px-2 sm:px-4 py-2 text-[11px] sm:text-sm md:text-base font-montserrat">
                          {(() => {
                            const correctas = Number(
                              resultado.total_correctas || 0
                            );
                            const incorrectas = Number(
                              resultado.total_incorrectas || 0
                            );
                            const sinActividad = correctas + incorrectas === 0;

                            // Si ya actualizaste el backend, vendrá curso_completo=1 cuando terminó el curso.
                            // Como respaldo, mantenemos la compat con certificado === "Aprobado".
                            const cursoCompleto =
                              Boolean(resultado.curso_completo) ||
                              resultado.certificado === "Aprobado";

                            const etiqueta = sinActividad
                              ? "Sin resultados"
                              : cursoCompleto
                              ? "Aprobado"
                              : "No Aprobado";

                            return (
                              <>
                                {etiqueta}
                                {cursoCompleto && (
                                  <button
                                    onClick={() =>
                                      handleDownloadCertificado(
                                        resultado.usuarioId ?? resultado.id, // <- id del usuario objetivo
                                        resultado.nombre,
                                        resultado.apellido ??
                                          resultado.apellidos ??
                                          ""
                                      )
                                    }
                                    title="Descargar certificado"
                                    className="inline-block align-middle"
                                  >
                                    <img
                                      src={Descargar}
                                      className="w-4 h-auto ml-3.5 inline-block"
                                      alt="Descargar certificado"
                                    />
                                  </button>
                                )}

                                {/* Ver resultados (modal) */}
                                <div className="mt-1">
                                  <button
                                    onClick={() => {
                                      setUsuarioResultados(resultado);
                                      setShowResultadosUsuario(true);
                                    }}
                                    className="text-green-700 hover:text-green-600 font-bold underline"
                                  >
                                    Ver resultados
                                  </button>
                                </div>
                              </>
                            );
                          })()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              {resultados.length === 0 && !error && (
                <p className="text-white font-montserrat italic mt-4">
                  No hay resultados disponibles.
                </p>
              )}

              {renderPaginationButtons()}

              <div className="mt-4 flex justify-center">
                <button
                  onClick={() => handleDownloadExcel("resultados")}
                  className="bg-white hover:bg-gray-200 hover:text-black font-bold py-2 px-4 rounded transition duration-300 ease-in-out text-sm sm:text-base transform-transition hover:shadow-[0_9px_20px_rgba(0,0,0,0.8)] transform hover:scale-105"
                >
                  Descargar excel
                </button>
              </div>
            </div>
          )}
        </div>
      </div>

      {showModal && selectedUsuario && (
        <DetallesResultados
          resultado={selectedUsuario}
          onClose={() => setShowModal(false)}
        />
      )}

      {usuarioEditar && (
        <EditarUsuario usuario={usuarioEditar} onClose={handleCerrarEdicion} />
      )}
      {showUpload && (
        <UploadUsuariosExcel
          onClose={() => setShowUpload(false)}
          onDone={() => window.location.reload()} // o llama a tu refetch si lo expones
        />
      )}

      {/* NUEVO: Modal Resultados del Usuario */}
      {showResultadosUsuario && usuarioResultados && (
        <ResultadosUsuarioModal
          usuarioFila={usuarioResultados}
          onClose={() => setShowResultadosUsuario(false)}
        />
      )}
    </div>
  );
};

// ===== Modal inline: Resultados del Usuario (detalle por nivel y tema) =====
function ResultadosUsuarioModal({ usuarioFila, onClose }) {
  const [niveles, setNiveles] = useState([]);
  const [temasPorNivel, setTemasPorNivel] = useState({});
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [open, setOpen] = useState({});
  const [tiempos, setTiempos] = useState({
    totalSesionMs: 0,
    totalPreguntasMs: 0,
    // totalFinalMs: 0, // si lo llegas a mostrar
  });

  const userId =
    usuarioFila?.usuarioId ?? usuarioFila?.idUsuario ?? usuarioFila?.id ?? null;

  const rolPlano = String(usuarioFila?.rol || "").toLowerCase();
  const isDocente =
    rolPlano.includes("docente") ||
    rolPlano.includes("teacher") ||
    rolPlano.includes("profesor");

  // Helpers
  const truthy = (v) => v === 1 || v === true || String(v) === "1";
  const safeName = (t, idx) =>
    t?.titulo || t?.nombre || t?.tema || `Tema ${idx + 1}`;
  const msToHMS = (ms) => {
    const s = Math.floor((Number(ms) || 0) / 1000);
    const hh = String(Math.floor(s / 3600)).padStart(2, "0");
    const mm = String(Math.floor((s % 3600) / 60)).padStart(2, "0");
    const ss = String(s % 60).padStart(2, "0");
    return `${hh}:${mm}:${ss}`;
  };

  useEffect(() => {
    const fetchData = async () => {
      if (!userId) {
        setErr("No se encontró el ID del usuario en la fila.");
        return;
      }
      setLoading(true);
      setErr("");

      try {
        const token = localStorage.getItem("token");
        const tokenHeaders = {
          headers: {
            Authorization: `Bearer ${token}`,
            "Cache-Control": "no-cache",
          },
          params: { t: Date.now() },
        };

        // 1) Niveles del usuario
        const { data: nivelesRaw } = await axios.get(
          `${API_BASE_URL}/api/resultados/usuario/${userId}`,
          tokenHeaders
        );

        const rows = Array.isArray(nivelesRaw) ? nivelesRaw : [];
        const nivelesNorm = rows
          .map((n) => ({
            ...n,
            desafio_final: truthy(n.desafio_final ?? n.completado),
            completado: truthy(n.completado),
          }))
          .sort((a, b) => (a.orden ?? 9999) - (b.orden ?? 9999))
          .filter((n) => n.orden !== 1)
          .slice(0, isDocente ? 5 : 4);

        setNiveles(nivelesNorm);

        // 2) Temas por nivel
        const requests = nivelesNorm.map((n) =>
          axios
            .get(
              `${API_BASE_URL}/api/temas/info/${n.id}/${userId}`,
              tokenHeaders
            )
            .then((res) => ({
              nivelId: n.id,
              temas: Array.isArray(res.data) ? res.data : [],
            }))
            .catch(() => ({ nivelId: n.id, temas: [] }))
        );
        const temasResults = await Promise.all(requests);
        const map = {};
        temasResults.forEach(({ nivelId, temas }) => (map[nivelId] = temas));
        setTemasPorNivel(map);
        if (nivelesNorm[0]?.id) setOpen({ [nivelesNorm[0].id]: true });

        // 3) >>> Resumen de tiempos (NUEVO)
        const { data: tdata } = await axios.get(
          `${API_BASE_URL}/api/tiempos/usuario/${userId}/resumen`,
          tokenHeaders
        );
        setTiempos({
          totalSesionMs: Number(tdata?.totalSesionMs || 0),
          totalPreguntasMs: Number(tdata?.totalPreguntasMs || 0),
          // totalFinalMs: Number(tdata?.totalFinalMs || 0),
        });
      } catch (e) {
        console.error("Error cargando niveles/temas/tiempos (admin modal):", e);
        setErr("No fue posible cargar el progreso del usuario.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, isDocente]);

  const puntajeTotal =
    usuarioFila && usuarioFila.total_correctas != null
      ? Number(usuarioFila.total_correctas)
      : niveles.reduce(
          (acc, n) => acc + (Number(n.respuestas_correctas) || 0),
          0
        );

  const nivelesCompletados = niveles.filter((n) =>
    truthy(n.desafio_final ?? n.completado)
  ).length;

  const getNivelStats = (nivel) => {
    const temas = temasPorNivel[nivel.id] || [];
    const total = temas.length + 1;
    const temasOk = temas.filter((t) => truthy(t.completado)).length;
    const finalOk = truthy(nivel.desafio_final ?? nivel.completado) ? 1 : 0;
    return { temas, total, completados: temasOk + finalOk };
  };

  const toggleOpen = (nivelId) =>
    setOpen((prev) => ({ ...prev, [nivelId]: !prev[nivelId] }));

  return (
    <div className="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl shadow-xl w-[95%] max-w-4xl p-5 relative max-h-[85vh] overflow-y-auto">
        <button
          onClick={onClose}
          className="absolute top-2 right-2 text-gray-500 hover:text-gray-700"
          aria-label="Cerrar"
        >
          ✕
        </button>

        <h2 className="text-xl sm:text-2xl font-extrabold text-center mb-2">
          Resultados del usuario – {usuarioFila?.nombre}
        </h2>
        <p className="text-center text-sm text-gray-600 mb-4">
          Rol: <span className="font-semibold">{usuarioFila?.rol}</span>
          {usuarioFila?.numcc && (
            <>
              {" · "}Documento:{" "}
              <span className="font-mono">{usuarioFila.numcc}</span>
            </>
          )}
        </p>

        {/* RESUMEN: mantenemos 3 tarjetas; la 3a ahora muestra los tiempos */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-6">
          {/* Puntaje total */}
          <div className="bg-green-700 text-white rounded-lg p-3 text-center flex flex-col items-center justify-center min-h-[110px]">
            <div className="text-4xl font-extrabold leading-none">
              {puntajeTotal}
            </div>
            <div className="text-sm opacity-90 mt-1">Puntaje total</div>
          </div>

          {/* Niveles completados */}
          <div className="bg-white border rounded-lg p-3 text-center flex flex-col items-center justify-center min-h-[110px]">
            <div className="text-3xl font-bold leading-none">
              {nivelesCompletados}/{niveles.length}
            </div>
            <div className="text-sm text-gray-600 mt-1">
              Niveles completados
            </div>
          </div>

          {/* Tiempos (opcional: también centrada para uniformidad) */}
          <div className="bg-white border rounded-lg p-3 text-center flex flex-col items-center justify-center min-h-[110px]">
            <div>
              <div className="text-sm text-gray-600">Tiempo en la app</div>
              <div className="text-xl font-bold">
                {msToHMS(tiempos.totalSesionMs)}
              </div>
            </div>
            <div className="mt-2">
              <div className="text-sm text-gray-600">Tiempo respondiendo</div>
              <div className="text-xl font-bold">
                {msToHMS(tiempos.totalPreguntasMs)}
              </div>
            </div>
          </div>
        </div>

        <h3 className="text-lg sm:text-xl font-extrabold mb-2">
          Progreso por nivel y tema
        </h3>

        <div className="space-y-3">
          {niveles.map((n, i) => {
            const { temas, total, completados } = getNivelStats(n);
            const label = n.orden ? `Nivel ${n.orden - 1}` : `Nivel ${i + 1}`;
            const abierto = !!open[n.id];

            return (
              <div key={n.id} className="border rounded-lg overflow-hidden">
                <button
                  onClick={() => toggleOpen(n.id)}
                  className="w-full flex items-center justify-between px-4 py-2 text-left bg-green-800"
                >
                  <span className="text-white font-bold">{label}</span>
                  <span className="text-white text-sm">
                    {completados}/{total} completados
                  </span>
                </button>

                {abierto && (
                  <div className="bg-white">
                    <table className="w-full text-sm">
                      <thead>
                        <tr className="bg-green-700 text-white">
                          <th className="text-left px-4 py-2">Tema</th>
                          <th className="text-left px-4 py-2">Estado</th>
                        </tr>
                      </thead>
                      <tbody>
                        {temas.map((t, idx) => (
                          <tr key={t.id || idx} className="border-b">
                            <td className="px-4 py-2">{safeName(t, idx)}</td>
                            <td className="px-4 py-2">
                              {truthy(t.completado) ? (
                                <span className="text-green-700 font-semibold">
                                  Aprobado
                                </span>
                              ) : (
                                <span className="text-gray-600">
                                  No completado
                                </span>
                              )}
                            </td>
                          </tr>
                        ))}
                        <tr className="border-t">
                          <td className="px-4 py-2 font-medium">
                            Desafío final
                          </td>
                          <td className="px-4 py-2">
                            {truthy(n.desafio_final ?? n.completado) ? (
                              <span className="text-green-700 font-semibold">
                                Aprobado
                              </span>
                            ) : (
                              <span className="text-gray-600">
                                No completado
                              </span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        {loading && (
          <div className="text-center text-sm text-gray-600 mt-4">
            Cargando…
          </div>
        )}
        {err && (
          <div className="text-center text-sm text-red-600 mt-4">{err}</div>
        )}

        <div className="mt-6 flex justify-center">
          <button
            onClick={onClose}
            className="bg-gray-200 hover:bg-gray-300 text-black font-semibold px-4 py-2 rounded"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
}

export default ListaUsuarios;
